function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#F65314;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#7FBB41;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#00A1F1;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFBB00;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M0.2,0.2h11.2l0,11.2H0.2L0.2,0.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M12.6,0.2h11.2c0,3.7,0,7.5,0,11.2c-3.7,0-7.5,0-11.2,0C12.6,7.7,12.6,4,12.6,0.2L12.6,0.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M0.2,12.6c3.7,0,7.5,0,11.2,0c0,3.7,0,7.5,0,11.2H0.2L0.2,12.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M12.6,12.6c3.7,0,7.5,0,11.2,0v11.2H12.6C12.6,20,12.6,16.3,12.6,12.6z"
}));

var SvgLogoMicrosoft = function SvgLogoMicrosoft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoMicrosoft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_microsoft.c3a19c9f.svg";
export { ForwardRef as ReactComponent };